export const TargetIcon = ({ activeColor }: { activeColor?: string }) => {
    return (
        <svg
            width="42"
            height="42"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Background Circle */}
            <circle
                cx="16"
                cy="16"
                r="16"
                fill="#EEF2FF"
            />

            {/* Outer Ring */}
            <circle
                cx="16"
                cy="16"
                r="7"
                stroke={activeColor}
                strokeWidth="1.8"
            />

            {/* Center Dot */}
            <circle
                cx="16"
                cy="16"
                r="2"
                fill={activeColor}
            />

            {/* Crosshair Lines */}
            <path
                d="M16 5V8"
                stroke={activeColor}
                strokeWidth="1.8"
                strokeLinecap="round"
            />

            <path
                d="M16 24V27"
                stroke={activeColor}
                strokeWidth="1.8"
                strokeLinecap="round"
            />

            <path
                d="M5 16H8"
                stroke={activeColor}
                strokeWidth="1.8"
                strokeLinecap="round"
            />

            <path
                d="M24 16H27"
                stroke={activeColor}
                strokeWidth="1.8"
                strokeLinecap="round"
            />
        </svg>
    );
}